<ng-container [caLocalizationScope]="localizationKey">
  <i
    #tooltip
    title="{{ 'bestFundTooltip' | caLocalize }}"
    [attr.data-tooltip-header]="'bestFundTooltipTitle' | caLocalize"
    class="f-i f-i-md f-i-target text-primary-600"
    [ngClass]="rootCssClass"
    (click)="openMobilePopover({ title: tooltip.dataset.tooltipHeader || '', text: tooltip.title })"
  ></i>
</ng-container>
